import { useMemo } from "react";
import { Image } from "@gluestack-ui/themed";

import { ListTile } from "@repo/core/components/layout/ListTile";
import { TileLabel } from "@repo/core/components/layout/ListTile/types";
import GenericCardImage from "@repo/core/assets/images/generic-card.jpg";

import { ProductListTileProps } from "./types";

export const ProductListTile = ({
  id,
  name,
  number = "0000",
  isSelectable,
  isActive,
  onPress
}: ProductListTileProps) => {
  const labels = useMemo(() => {
    return [
      new TileLabel({
        text: name || "",
        fontColor: "$textLight900",
        fontFamily: "inter",
        fontWeight: 600,
        fontSize: "sm"
      }),
      new TileLabel({
        fontColor: "$textLight800",
        text: number,
        fontFamily: "inter",
        fontWeight: 400,
        fontSize: "sm"
      })
    ];
  }, [name, number]);

  return (
    <ListTile
      id={id}
      onPress={onPress}
      labels={labels}
      isSelectable={isSelectable}
      isActive={isActive}
      leading={
        <Image
          w={"$24"}
          h={"$16"}
          alt="Avatar"
          source={GenericCardImage}
          borderColor={"$borderLight300"}
        />
      }
    />
  );
};
